<app-header></app-header>

<div style="text-align: center; width: 100%">
  <h1 style="margin-bottom: 10px;">{{"REFERRAL.TITLE" | translate }}</h1>
  <h3>{{"REFERRAL.SUBTITLE" | translate}}</h3>
  <img alt="kingcard with friends" src="assets/img/referral/king-friends.png" style="width: 80%; max-width: 500px; min-width: 200px;" />
</div>

<mat-card class="step-card">
  <mat-card-header>
    <mat-card-title>

    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div style="text-align: center;">

    <div>

      <div style="font-size: 1.1em; padding: 10px;">
        {{ 'REFERRAL.ENTER_MOBILE' | translate }}
      </div>

      <mat-form-field style="width: 300px;">
        <input matInput type="text" [placeholder]="'ORDER.MOBILE.FORM.MOBILE' | translate" [(ngModel)]="phoneNumber" [imask]="phoneMask"
               [unmask]="true" [disabled]="isLoading" minlength="10" maxlength="15" #phoneNumberForm="ngModel" required>
        <mat-error *ngIf="phoneNumberForm.invalid">
          {{'ORDER.FULL_NAME.FORM.REQUIRED_PHONE_FORMAT' | translate}}
        </mat-error>

      </mat-form-field>

    </div>

    <button mat-raised-button [disabled]="isLoading" color="primary" type="submit" (click)="submitPhone();">{{'BUTTON.NEXT' | translate }}</button>

    </div>

  </mat-card-content>
  <mat-card-actions align="end">

  </mat-card-actions>
</mat-card>
